import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import { MobileMenuLink, useUserInfoContext } from '../..';

import { DSIcon } from '../../../base';

import { MOBILE_APP_BUTTONS } from './utils';
import MobileAppButton from './MobileAppButton';

import styles from './MobileMenu.module.scss';
import SeparatorRedesign from './SeparatorRedesign';

const cx = classNames.bind(styles);

const MobileMenu = ({
  color = 'dark',
  className = '',
  logo = '',
  children = undefined,
  onClose = () => {},
  isRedesign = false
}) => {
  const mobileMenuClassnames = cx(styles.mobileMenu, styles[color], className);

  const { isUserLogged } = useUserInfoContext();

  const handleClose = () => {
    onClose();
  };

  const footerClasses = cx(styles.footer, {
    [styles['footer--redesign']]: isRedesign
  });

  const footerTitleClasses = cx(styles.footer_title, {
    [styles['footer_title--redesign']]: isRedesign
  });

  return (
    <div className={mobileMenuClassnames}>
      <div className={styles.headWrapper}>
        {logo}
        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}
        >
          <DSIcon name="close" className={styles.closeIcon} />
        </button>
      </div>
      <div className={styles.content}>{children}</div>
      <div className={footerClasses}>
        <strong className={footerTitleClasses}>{trans('menu.footer')}</strong>
        <div className={styles.footer_actions}>
          {Object.keys(MOBILE_APP_BUTTONS).map(key => (
            <MobileAppButton key={key} {...MOBILE_APP_BUTTONS[key]} />
          ))}
        </div>
      </div>
      {isUserLogged && isRedesign && (
        <div className={styles.content}>
          <SeparatorRedesign />
          <MobileMenuLink href={getPagePath('logout')}>
            {trans('logout.text')}
          </MobileMenuLink>
        </div>
      )}
    </div>
  );
};

MobileMenu.propTypes = {
  color: PropTypes.oneOf(['dark', 'light']),
  className: PropTypes.string,
  logo: PropTypes.node,
  children: PropTypes.node,
  onClose: PropTypes.func,
  isRedesign: PropTypes.bool
};

export default MobileMenu;
